"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayOpacitySchedule = exports.DayOpacitySchedule = void 0;
const swagger_1 = require("@nestjs/swagger");
class DayOpacitySchedule {
    isOperative;
    timetable;
}
exports.DayOpacitySchedule = DayOpacitySchedule;
class DisplayOpacitySchedule {
    mon;
    tue;
    wed;
    thu;
    fri;
    sat;
    sun;
}
exports.DisplayOpacitySchedule = DisplayOpacitySchedule;
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Monday opacity schedule configuration",
        type: DayOpacitySchedule,
        example: {
            isOperative: true,
            timetable: [{ from: 28800, to: 64800, opacity: 0.5 }],
        },
    }),
    __metadata("design:type", DayOpacitySchedule)
], DisplayOpacitySchedule.prototype, "mon", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Tuesday opacity schedule configuration",
        type: DayOpacitySchedule,
        example: {
            isOperative: true,
            timetable: [{ from: 28800, to: 64800, opacity: 0.5 }],
        },
    }),
    __metadata("design:type", DayOpacitySchedule)
], DisplayOpacitySchedule.prototype, "tue", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Wednesday opacity schedule configuration",
        type: DayOpacitySchedule,
        example: {
            isOperative: true,
            timetable: [{ from: 28800, to: 64800, opacity: 0.5 }],
        },
    }),
    __metadata("design:type", DayOpacitySchedule)
], DisplayOpacitySchedule.prototype, "wed", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Thursday opacity schedule configuration",
        type: DayOpacitySchedule,
        example: {
            isOperative: true,
            timetable: [{ from: 28800, to: 64800, opacity: 0.5 }],
        },
    }),
    __metadata("design:type", DayOpacitySchedule)
], DisplayOpacitySchedule.prototype, "thu", void 0);
